export default {
    data: [
        { key: 'companies-evol', label: 'companies-evol' },
        { key: 'companies', label: 'companies' },
        { key: 'funds-perf', label: 'funds-perf' },
        { key: 'funds', label: 'funds' },
        { key: 'gps', label: 'gps' },
        { key: 'trans-perf', label: 'trans-perf' },
        { key: 'trans', label: 'trans' },
    ],
}
